export type NavItem = {
  id: string
  navItemType: "Link"
  href: string
  text: string
}

export type NavItemGroup = {
  id: string
  navItemType: "Group"
  name: string
  navItems: NavItemSubGroup[] | NavItem[]
}

export type NavItemSubGroup = {
  id: string
  navItemType: "SubGroup"
  name: string
  navItems: NavItem[]
}

export interface HeaderData {
  navItems: (NavItem | NavItemGroup)[]
}

export const navigationData: HeaderData = {
  navItems: [
    {
      id: "nav-news",
      navItemType: "Link",
      href: "/news",
      text: "Neuigkeiten",
    },
    {
      id: "nav-mannschaften",
      navItemType: "Group",
      name: "Mannschaften",
      navItems: [
        {
          id: "subgroup-senioren",
          navItemType: "SubGroup",
          name: "Senioren",
          navItems: [
            {
              id: "team-1",
              navItemType: "Link",
              href: "/mannschaften?team-1",
              text: "Team 1",
            },
            {
              id: "team-2",
              navItemType: "Link",
              href: "/mannschaften?team-2",
              text: "Team 2",
            },
            {
              id: "team-3",
              navItemType: "Link",
              href: "/mannschaften?team-3",
              text: "Team 3",
            },
          ],
        },
        {
          id: "subgroup-junioren",
          navItemType: "SubGroup",
          name: "Junioren",
          navItems: [
            {
              id: "team-4",
              navItemType: "Link",
              href: "/mannschaften?team-4",
              text: "A-Jugend",
            },
            {
              id: "team-5",
              navItemType: "Link",
              href: "/mannschaften?team-5",
              text: "B-Jugend",
            },
            {
              id: "team-6",
              navItemType: "Link",
              href: "/mannschaften?team-6",
              text: "C1-Jugend",
            },
            {
              id: "team-7",
              navItemType: "Link",
              href: "/mannschaften?team-7",
              text: "C2-Jugend",
            },
            {
              id: "team-8",
              navItemType: "Link",
              href: "/mannschaften?team-8",
              text: "D-Jugend",
            },
            {
              id: "team-9",
              navItemType: "Link",
              href: "/mannschaften?team-9",
              text: "E-Jugend",
            },
            {
              id: "team-10",
              navItemType: "Link",
              href: "/mannschaften?team-10",
              text: "F-Jugend",
            },
            {
              id: "team-11",
              navItemType: "Link",
              href: "/mannschaften?team-11",
              text: "G-Junioren",
            },
            {
              id: "team-12",
              navItemType: "Link",
              href: "/mannschaften?team-12",
              text: "Mini-Kickers",
            },
          ],
        },
        {
          id: "subgroup-dart",
          navItemType: "SubGroup",
          name: "Dart",
          navItems: [
            {
              id: "team-13",
              navItemType: "Link",
              href: "/mannschaften?team-13",
              text: "Team 1",
            },
            {
              id: "team-14",
              navItemType: "Link",
              href: "/mannschaften?team-14",
              text: "Team 2",
            },
          ],
        },
      ],
    } as NavItemGroup,
    {
      id: "nav-platzbelegung",
      navItemType: "Link",
      href: "/platzbelegungsplan",
      text: "Platzbelegungsplan",
    },
    {
      id: "nav-verein",
      navItemType: "Group",
      name: "Verein",
      navItems: [
        {
          id: "verein-about",
          navItemType: "Link",
          href: "/der-fc-ottenhoefen-1956-e-v-stellt-sich-vor",
          text: "FCO stellt sich vor",
        },
        {
          id: "verein-erfolge",
          navItemType: "Link",
          href: "/sportliche-erfolge",
          text: "Sportliche Erfolge",
        },
        {
          id: "verein-vorstand",
          navItemType: "Link",
          href: "/vorstandschaft",
          text: "Vorstandschaft",
        },
        {
          id: "verein-kontakte",
          navItemType: "Link",
          href: "/kontakte",
          text: "Kontakte",
        },
        {
          id: "verein-stadion",
          navItemType: "Link",
          href: "/hasenwaldstadion",
          text: "Hasenwaldstadion",
        },
        {
          id: "verein-clubhaus",
          navItemType: "Link",
          href: "/clubhaus",
          text: "Clubhaus",
        },
        {
          id: "verein-mitgliedschaft",
          navItemType: "Link",
          href: "/mitgliedschaft",
          text: "Mitgliedschaft",
        },
        {
          id: "verein-freizeit",
          navItemType: "Link",
          href: "/freizeitabteilung",
          text: "Freizeitabteilung",
        },
      ],
    },
    {
      id: "nav-sponsoring",
      navItemType: "Link",
      href: "/sponsoring",
      text: "Sponsoring",
    },
  ],
}
